import React from "react";
import { RestrictedToAdmin } from "components/auth";
import { NotAllowedPage } from "components/page";

const withAdminPermissions = Page => {
  const PageWithAdminPermissions = props => (
    <RestrictedToAdmin fallback={<NotAllowedPage />}>
      <Page {...props} />
    </RestrictedToAdmin>
  );

  const pageName = Page.displayName || Page.name || "Unknown";
  PageWithAdminPermissions.displayName = `WithAdminPermissions(${pageName})`;

  return PageWithAdminPermissions;
};

export default withAdminPermissions;
